import { render, staticRenderFns } from "./UserFollowing.vue?vue&type=template&id=679c9a19&scoped=true&"
import script from "./UserFollowing.vue?vue&type=script&lang=js&"
export * from "./UserFollowing.vue?vue&type=script&lang=js&"
import style0 from "./UserFollowing.vue?vue&type=style&index=0&id=679c9a19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679c9a19",
  null
  
)

export default component.exports